import moment from 'moment';
import { Item } from 'shared-types';
import { useTranslations } from '@lang';
import { BasketDrawerTextWrapper, BasketItemText, Listing } from '../BasketDrawer.styles';
import { pluralizeGuests } from '../BasketDrawer.helpers';

export const SpaListing = ({
  spa,
  hideArrivalTimes,
}: {
  spa: Item[];
  hideArrivalTimes: boolean;
}) => {
  const { t } = useTranslations();

  return (
    <Listing>
      {(spa ?? []).map((item) => {
        const guestDetails = item?.guestDetails ?? [];

        // flatMap e.g. from [[{name: 'towel'}], [{name: 'big towel'}]] to [{name: 'towel'}, {name: 'big towel'}]
        const allGuestExtras = guestDetails.flatMap((guest) => guest.extras ?? []);

        // Group extras by ID and count occurrences
        let groupedExtras: Record<string, { name: string; count: number }> = {};
        groupedExtras = allGuestExtras.reduce((acc, extra) => {
          const id = String(extra.id);
          if (!acc[id]) {
            acc[id] = { name: extra.name, count: 0 };
          }
          acc[id].count += 1;
          return acc;
        }, {});

        return (
          <div data-testId="spa-listing" key={item.id}>
            {!hideArrivalTimes && (
              <BasketDrawerTextWrapper>
                {moment(item?.checkIn).format('ddd, D MMM')} -{' '}
                {moment(item?.checkIn).format('HH:mm')}
              </BasketDrawerTextWrapper>
            )}
            <BasketDrawerTextWrapper marginBottom="10px" columns={2}>
              <BasketItemText>{item?.bookable?.name}</BasketItemText>
              <BasketItemText>
                {item?.guestDetails?.length}
                {` ${pluralizeGuests(item?.guestDetails?.length ?? 1, t)}`}
              </BasketItemText>
            </BasketDrawerTextWrapper>
            {Object.keys(groupedExtras).length > 0 &&
              Object.entries(groupedExtras).map(([id, { name, count }]) => (
                <BasketDrawerTextWrapper key={id} marginBottom="10px">
                  <BasketItemText>
                    {name} x {count}
                  </BasketItemText>
                </BasketDrawerTextWrapper>
              ))}
          </div>
        );
      })}
    </Listing>
  );
};
